import { EXPLORE_FILTER_TAG } from './use-experience-filter';
import useSetFilter, { TagKey } from './use-set-filter';

const useSetTag = () => useSetFilter<TagKey | undefined>(EXPLORE_FILTER_TAG);

export default useSetTag;
